module.exports = __webpack_public_path__ + "img/8. Pricing TCA, TCE, TCW.ad799e08.jpg";